export const PERSONA_TYPE_DIRECTOR = "DIRECTOR" as const;
export const PERSONA_TYPE_OFFICER = "OFFICER" as const;
export const PERSONA_TYPE_SHAREHOLDER = "SHAREHOLDER" as const;

export const AP_STATUS_ACTIVE = "ACTIVE" as const;
export const AP_STATUS_FORMER = "FORMER" as const;

export const SHAREHOLDER_TYPE_PERSONA = "PERSONA" as const;
